import { Quote } from '../../../../../../shared/models/vendor-order.model';
import { QuoteCostItem } from './quote-cost-card.component';

export function buildCostBreakdown(quote: Quote): QuoteCostItem[] {
  if (quote.costs?.length) return quote.costs;

  const items: QuoteCostItem[] = [];
  if (quote.dtpCost != null) {
    items.push({ concept: 'Desktop publishing', cost: quote.dtpCost });
  }
  if (quote.translationCost != null) {
    items.push({ concept: 'Translation cost', cost: quote.translationCost });
  }
  if (quote.managementCost != null) {
    items.push({ concept: 'Management', cost: quote.managementCost });
  }
  if (quote.rushedFees != null) {
    items.push({ concept: 'Rushed fees', cost: quote.rushedFees });
  }
  return items;
}

const CONCEPT_ALIASES: Record<string, string> = {
  'file preparation': 'translation cost',
};

const normalizeConcept = (concept: string): string => {
  const key = concept.trim().toLowerCase();
  return CONCEPT_ALIASES[key] ?? key;
};

/** Positive per-concept cost increases of `reanalysisItems` over `baseQuote`. */
export function computeCostDeltas(
  baseQuote: Quote,
  reanalysisItems: QuoteCostItem[],
): ReadonlyMap<string, number> {
  const baseCosts = new Map(
    buildCostBreakdown(baseQuote).map((item) => [
      normalizeConcept(item.concept),
      item.cost,
    ]),
  );

  return new Map(
    reanalysisItems
      .map((item) => {
        const previousCost = baseCosts.get(normalizeConcept(item.concept)) ?? 0;
        return [item.concept, item.cost - previousCost] as const;
      })
      .filter(([, delta]) => delta > 0),
  );
}
